module.exports = __webpack_public_path__ + "static/media/portfolio-9.116ca194.webp";